export default __webpack_public_path__ + "6386c05c355ee8b58b9ed50dbdb485fc.svg";